<template>
  <div class="invoice-screen" :class="{'open': addClass}" v-if="screenShow">
    <div class="opative div-show" @click="close"></div>
    <div class="screen-content">
      <div class="screen-content-header">
        <div class="remove" @click="close">
          <img src="../../../assets/img/del-icon.png" alt="">
        </div>
        选择筛选条件
      </div>

      <ul class="info-item-list">
        <li class="info-item">
          <div class="info-item-title">金额</div>
          <div class="money-screen-box">
            <div class="money-input">
              <span class="m-icon">¥</span>
              <input type="number" name="" placeholder="最低金额" v-model="minMoney">
            </div>
            <div class="money-icon">-</div>
            <div class="money-input">
              <span class="m-icon">¥</span>
              <input type="number" name="" placeholder="最高金额" v-model="maxMoney">
            </div>
          </div>
        </li>
      </ul>

      <div class="screen-btn">
        <button class="reset" @click="reset">重置</button>
        <button class="confirm" @click="confirm">确认</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pi-invoice-screen',
  data(){
    return{
      screenShow: false,
      addClass: false,
      minMoney: '',
      maxMoney: '',
    }
  },
  methods: {
    open(){
      this.screenShow = true;
      setTimeout(()=>{
        this.addClass = true;
      })
    },
    close(){
      this.addClass = false;
      setTimeout(()=>{
        this.screenShow = false;
      },300)
    },
    reset(){
      this.minMoney = '';
      this.maxMoney = '';
    },
    confirm(){
      if(this.minMoney > this.maxMoney){
        this.$toast('最小金额不能大于最大金额');
      }else{
        this.$emit("confirm",{
          minMoney: this.minMoney,
          maxMoney: this.maxMoney,
        })
        this.close();
      }
    }
  },
}
</script>
<style lang="less">
.invoice-screen{
  .opative{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0,0,0,0.5);
  }
  .screen-content{
    height: 100%;
    position: fixed;
    width: 6.6rem;
    left: 0.9rem;
    background-color: #fff;
    border-radius: 0.2rem 0px 0px 0px;
    top: 0;
    display: flex;
    flex-direction: column;
    transform: translateX(100%);
    transition: 0.3s all;
  }
  .screen-content-header{
    padding: 0.2rem;
    font-size: 0.28rem;
    line-height: 0.4rem;
    text-align: center;
    color: #000;
    position: relative;
    
  }
  .remove{
    position: absolute;
    padding: 0.21rem;
    left: 0;
    top: 0;
    width: 0.27rem;
    height: 0.27rem;  
  }
  .info-item-list{
    padding: 0 0.2rem;
    flex: 1;
  }
  .info-item-title{
    font-size: 0.27rem;
    line-height: 0.38rem;
    color: #333;
    padding-bottom: 0.1rem;
    border-bottom: 1px solid #C3C3C3;
    position: relative;
  }
  .info-item-title:after{
    content:'';
    position: absolute;
    width: 0.2rem;
    height: 0.02rem;
    background-color: #979797;
    bottom: 0;
    left: 0;
  }
  .money-screen-box{
    margin-top: 0.2rem;
    display: flex;

  }
  .money-input{
    padding: 0.15rem 0.15rem 0.15rem 0.37rem;
    position: relative;
    flex: 1;
    background-color: #FAFAFA;
    line-height: 0.4rem;
    font-size: 0.28rem;
     color:#666666;
    input{
      width: 100%;
      height: 0.4rem;
      font-size: 0.28rem;
      line-height: 0.4rem;
    }
    .m-icon{
      position: absolute;
      width: 0.37rem;
      text-align: center;
      left: 0;
      top: 0;
      display: block;
      padding: 0.15rem 0;
    }
  }
  .money-icon{
    width: 1rem;
    text-align: center;
  }
  .screen-btn{
    padding: 0.4rem;
    display: flex;
  }
  .screen-btn button{
    flex: 1;
    font-size: 0.26rem;
    line-height: 0.7rem;
    text-align: center;
  }
  .screen-btn button:active{
    opacity: 0.7;
  }
  .screen-btn button.reset{
    border:1px solid #14CC80;
    border-radius: 0.05rem;
    color:#14CC80;
    background-color: #fff;
    margin-right: 0.4rem;
  }
  .screen-btn button.confirm{
    background-color: #14CC80;
    color: #fff;
    border:none
  }
}
.invoice-screen.open{
  .opative{
    display: block;
  }
  .screen-content{
    transform: translateX(0);
  }
}
</style>